import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';
import { type PromocodeGroupUpdateBody as SchemaPromocodeGroupUpdateBody } from '../schemas/PromocodeGroupUpdateBody';
import { type PromocodeGroupWriteResponse as SchemaPromocodeGroupWriteResponse } from '../schemas/PromocodeGroupWriteResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Обновляет существующую группу промокодов
 * @tags PromocodeGroups
 * @summary Обновление группы промокодов
 */
export const PromocodeGroupUpdateContentType = 'application/json' as const;
export type PromocodeGroupUpdateRequest = SchemaPromocodeGroupUpdateBody;
export type PromocodeGroupUpdateResponses = LinkCommonErrorResponses & {
    /**
     * @description Запрос обработан
     */
    '200': {
        'application/json': SchemaPromocodeGroupWriteResponse;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupUpdateResponseSuccess = PromocodeGroupUpdateResponses['200']['application/json'];
export type PromocodeGroupUpdateSearchParams = undefined;
export type PromocodeGroupUpdatePathParameters = {
    id: string;
};
export const PromocodeGroupUpdateUrl = '/promocode_groups/{id}' as const;
export const PromocodeGroupUpdateMethod = 'PUT' as const;
export const getPromocodeGroupUpdateUrl = (params: PromocodeGroupUpdatePathParameters) =>
    PromocodeGroupUpdateUrl.replace(/\{(\w+)\}/g, (_match, param: keyof PromocodeGroupUpdatePathParameters) =>
        String(params[param])
    );
